// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";

function div(x, y) {
  if (y === 0) {
    throw new Caml_js_exceptions.MelangeError("Division_by_zero", {
          MEL_EXN_ID: "Division_by_zero"
        });
  }
  return x / y | 0;
}

function mod_(x, y) {
  if (y === 0) {
    throw new Caml_js_exceptions.MelangeError("Division_by_zero", {
          MEL_EXN_ID: "Division_by_zero"
        });
  }
  return x % y;
}

export {
  div,
  mod_,
}
/* No side effect */
